import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import * as en from "./en";
import * as ar from "./ar";

const ns = Object.keys(en);

export const defaultNS = ns[0];

void i18n.use(initReactI18next).init({
  ns,
  defaultNS,
  resources: {
    en,
    ar,
  },
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
    format: (value, format) => {
      if (format === "ltr") {
        const str = value == null ? "" : String(value);
        // Force LTR rendering for phone numbers/IDs inside RTL text
        return `\u2066${str}\u2069`; // LRI ... PDI
      }
      return value;
    },

  },
  compatibilityJSON: "v3",
});

export default i18n;
